// O nginx de entrada troca este marcador pelo nonce da requisicao ao servir o index.html. Enquanto a
// troca nao estiver ligada o marcador chega literal ao navegador, e carimba-lo num script seria pior
// que nao carimbar nada: o container do GTM repassa o valor recebido as tags que injeta.
export const CSP_NONCE_PLACEHOLDER = '__CSP_NONCE__';

export const getCspNonce = (): string | null => {
  const content = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content');

  if (!content || content === CSP_NONCE_PLACEHOLDER) {
    return null;
  }

  return content;
};
